'use strict';

// ----------------------------------------
// Private
// ----------------------------------------

let $searchWrap = $('.header__search-wrap');
let $searchBox = $('.header__search-hidden');
let $searchButton = $('.header__search-btn');
let $dropdown = $('.header__top-dropdown');
let $dropdownBtn = $('.header__top-dropdown-btn');
let $dropdownIcon = $('.header__lang-icon');
let $dropdownWrap = $('.header__top-dropdown-wrap');

// ----------------------------------------
// Public
// ----------------------------------------

function headerSearch () {
	$searchButton.on('click', function () {
		let $searchWrap = $(this).closest('.header__search-wrap'),
			$searchBox = $searchWrap.find('.header__search-hidden');
		if ($searchBox.hasClass('open')) {
			$searchBox.children('.js-form')[0].reset();
		}

		$(this).toggleClass('active');
		$searchWrap.toggleClass('open');
		$searchBox.toggleClass('open');
	});

	$('.header__search-input').keypress(function (event) {
		if (event.which === 13) {
			event.preventDefault();
			$(this).closest('.js-form').submit();
		}
	});

	$(document).click(function (e) {
		if (!$searchWrap.is(e.target) && $searchWrap.has(e.target).length === 0) {
			$searchBox.removeClass('open');
			$searchWrap.removeClass('open');
			$searchButton.removeClass('active');
			$searchBox.children('.js-form')[0].reset();
		}
	});
}

function headerLang () {
	$dropdownBtn.on('click', function () {
		let $dropdownWrap = $(this).closest('.header__top-dropdown-wrap'),
			$dropdown = $dropdownWrap.find('.header__top-dropdown');

		$dropdownWrap.toggleClass('open');
		$dropdown.slideToggle('fast');
		$dropdownIcon.toggleClass('open');
	});

	$(document).click(function (e) {
		if (!$dropdownWrap.is(e.target) && $dropdownWrap.has(e.target).length === 0) {
			$dropdown.slideUp('fast');
			$dropdownIcon.removeClass('open');
			$dropdownWrap.removeClass('open');
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {headerSearch, headerLang};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/header.js